import { Action } from '@ngrx/store';

export enum QuartelActionTypes {
    QUARTEL_EDIT = '[QUARTEL] QuartelEdit',
    QUARTEL_EDITED = '[QUARTEL] QuartelEdited',
    QUARTEL_ADD = '[QUARTEL] QuartelAdd',
    QUARTEL_ADDED = '[QUARTEL] QuartelAdded',
    QUARTEL_DELETE = '[QUARTEL] QuartelDelete',
    QUARTEL_DELETED = '[QUARTEL] QuartelDeleted',
    QUARTEL_GET_PAGE = '[QUARTEL] QuartelGetPage',
    QUARTEL_PAGE_LOADED = '[QUARTEL] QuartelPageLoaded',
    QUARTEL_GET_ALL = '[QUARTEL] QuartelGetAll',
    QUARTEL_ALL_LOADED = '[QUARTEL] QuartelAllloaded'
}

export class QuartelAdd implements Action {
    readonly type = QuartelActionTypes.QUARTEL_ADD;
    constructor(public payload: any) {}
}

export class QuartelEdit implements Action {
    readonly type = QuartelActionTypes.QUARTEL_EDIT;
    constructor(public payload: any) {}
}

export class QuartelGetPage implements Action {
    readonly type = QuartelActionTypes.QUARTEL_GET_PAGE;
    constructor(public payload: any) {}
}

export class QuartelPageLoaded implements Action {
    readonly type = QuartelActionTypes.QUARTEL_PAGE_LOADED;
    constructor(public payload: any) {}
}

export class QuartelAdded implements Action {
    readonly type = QuartelActionTypes.QUARTEL_ADDED;
    constructor(public payload: any) {}
}

export class QuartelEdited implements Action {
    readonly type = QuartelActionTypes.QUARTEL_EDITED;
    constructor(public payload: any) {}
}

export class QuartelDelete implements Action {
    readonly type = QuartelActionTypes.QUARTEL_DELETE;
    constructor(public payload: any) {}
}

export class QuartelDeleted implements Action {
    readonly type = QuartelActionTypes.QUARTEL_DELETED;
    constructor(public payload: any) {}
}

export class QuartelGetAll implements Action {
    readonly type = QuartelActionTypes.QUARTEL_GET_ALL;
    constructor(public payload: any) {}
}

export class QuartelAllLoaded implements Action {
    readonly type = QuartelActionTypes.QUARTEL_ALL_LOADED;
    constructor(public payload: any) {}
}

export type QuartelActions =
                | QuartelAdd
                | QuartelEdit
                | QuartelGetPage
                | QuartelPageLoaded
                | QuartelAdded
                | QuartelDeleted
                | QuartelDelete 
                | QuartelEdited
                | QuartelGetAll
                | QuartelAllLoaded;